import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c1ad528&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4c1ad528&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ad528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1ad528')) {
      api.createRecord('4c1ad528', component.options)
    } else {
      api.reload('4c1ad528', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c1ad528&scoped=true", function () {
      api.rerender('4c1ad528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/MenuCategory/index.vue"
export default component.exports